import { InjectionToken } from '@angular/core';
import { StorageService } from '../models/storage.interface';

export const STORAGE_TOKEN: InjectionToken<StorageService> = new InjectionToken<StorageService>('Token for storage');
